import axios from 'axios'

const PaymentVoucherService = {
  async get (params = {}) {
    return axios.get('auditor/payment-requests', { params })
  },

  async post (params) {
    return axios.post('auditor/payment-requests', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`auditor/payment-requests/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`auditor/payment-requests/${data.id}`, { data })
  }
}

export default PaymentVoucherService
